import { render, staticRenderFns } from "./LearningGoalTestResults.vue?vue&type=template&id=7b307fd6&"
import script from "./LearningGoalTestResults.vue?vue&type=script&lang=js&"
export * from "./LearningGoalTestResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports